
export const getCategoryPathFromPath = (path: string) => {
  const categoryFromPath = path.split('/').slice(3).join('/').replace(/\/?$/, '/')

  if (categoryFromPath.length <= 1) {
    return null
  }

  return categoryFromPath
}